module.exports = __webpack_public_path__ + "img/plus-white.a2d4e54d.svg";